import { axisAlignedBounds } from "./alignmentGuides";

export const MARQUEE_MIN_SIZE_PX = 4;

export const marqueeOverlaySx = ({ x, y, w, h }) => ({
  position: "absolute",
  left: x,
  top: y,
  width: w,
  height: h,
  border: "1.5px dashed #2563EB",
  backgroundColor: "rgba(37, 99, 235, 0.12)",
  pointerEvents: "none",
  zIndex: 22,
});

export const normalizeMarqueeRect = ({ originX, originY, x, y }) => ({
  x: Math.min(originX, x),
  y: Math.min(originY, y),
  w: Math.abs(x - originX),
  h: Math.abs(y - originY),
});

const rectsIntersect = (left, right) =>
  left.x < right.x + right.width &&
  left.x + left.width > right.x &&
  left.y < right.y + right.height &&
  left.y + left.height > right.y;

export const idsIntersectingMarquee = ({
  boxes = [],
  marquee,
  toBounds,
  skip,
}) => {
  if (!marquee) return [];
  const width = Number(marquee.w) || 0;
  const height = Number(marquee.h) || 0;
  if (width < MARQUEE_MIN_SIZE_PX && height < MARQUEE_MIN_SIZE_PX) return [];
  const rect = {
    x: Number(marquee.x) || 0,
    y: Number(marquee.y) || 0,
    width,
    height,
  };
  return boxes
    .filter((box) => {
      if (skip?.(box)) return false;
      const bounds = toBounds(box);
      if (!bounds) return false;
      const aabb = axisAlignedBounds(bounds);
      return rectsIntersect(rect, aabb);
    })
    .map((box) => box.id)
    .filter(Boolean);
};
